import { useContext } from "react";
import { GenerateGamesContext } from "./GenerateGamesContext";
import { GenerateGamesModel } from "./GenerateGamesModel";

function useInitializeGenerateGames() {
  const { setElement, setShowModal, setModelId } = useContext(
    GenerateGamesContext
  );
  return (id: number) => {
    setModelId(id);
    setElement(new GenerateGamesModel());
    setShowModal(true);
  };
}

export default useInitializeGenerateGames;
